import React, {useEffect, useState} from 'react';
import {useQuery} from 'react-apollo-hooks';

import {Card, Input, Loading} from 'ui-kit';

import {SortPill, MembersList} from './components';
import {ALL_MEMBERS_QUERY} from './graphql/AllMembers';

import * as styles from './AllMembers.module.css';

const DEFAULT_SORT = 'created_at:desc';

function AllMembers() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlSearch = urlSearchParams.get('search');
  const [search, setSearch] = useState(urlSearch == null ? '' : urlSearch);
  const [debouncedSearch, setDebouncedSearch] = useState(
    urlSearch == null ? null : urlSearch,
  );

  const urlSort = urlSearchParams.get('sort');
  const [field, direction] =
    urlSort == null ? DEFAULT_SORT.split(':') : urlSort.split(':');
  const [sort, setSort] = useState({
    field: field.toUpperCase(),
    direction: direction.toUpperCase(),
  });

  useEffect(
    () => {
      const handle = setTimeout(() => {
        setDebouncedSearch(search === '' ? null : search);
      }, 500);

      return () => {
        clearTimeout(handle);
      };
    },
    [search],
  );

  useEffect(
    () => {
      urlSearchParams.set(
        'sort',
        `${sort.field.toLowerCase()}:${sort.direction.toLowerCase()}`,
      );

      if (search === '') {
        urlSearchParams.delete('search');
      } else {
        urlSearchParams.set('search', search);
      }
      window.history.pushState({}, '', `?${urlSearchParams.toString()}`);
    },
    [sort.field, sort.direction, search, urlSearchParams],
  );

  const {data, error, loading} = useQuery(ALL_MEMBERS_QUERY, {
    variables: {query: debouncedSearch, sort},
    fetchPolicy: 'network-only',
  });

  if (error) {
    console.error(error);
    return (
      <Card>
        <p>An error occurred. Try refreshing this page or come back later.</p>
      </Card>
    );
  }

  function handleSortClick(field) {
    let direction;
    if (field !== sort.field) {
      direction = 'DESC';
    } else if (sort.direction === 'DESC') {
      direction = 'ASC';
    } else {
      direction = 'DESC';
    }

    setSort({field, direction});
  }

  const members = loading
    ? []
    : data.me.practice.memberV2s.edges.map(({node}) => node);

  const totalMembers = loading ? null : data.me.practice.memberV2Count;

  return (
    <Card noSpacing>
      <div className={styles.FiltersContainer}>
        <div className={styles.SearchContainer}>
          <Input
            onChange={event => {
              const {value} = event.target;
              setSearch(value);
            }}
            value={search}
            placeholder="Filter by name"
            noPadding
          />
        </div>

        <div className={styles.FiltersAndSorting}>
          <div className={styles.SortingContainer}>
            <p>
              <strong>Sort by:</strong>
            </p>
            <SortPill
              currentSort={sort}
              onClick={handleSortClick}
              field="CREATED_AT"
            >
              Date added
            </SortPill>
            <SortPill
              currentSort={sort}
              onClick={handleSortClick}
              field={'EXPIRATION'}
            >
              Expiration date
            </SortPill>
          </div>
          <div>{/* TODO: Filters */}</div>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <MembersList empty={totalMembers === 0} members={members} />
      )}
    </Card>
  );
}

export default AllMembers;
